import { io } from "socket.io-client";

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  (window.location.hostname === "localhost" ? "http://localhost:5000" : window.location.origin);

let socket = null;

export const getSocket = () => {
  if (!socket) {
    const token =
      localStorage.getItem("authToken") ||
      localStorage.getItem("token");

    socket = io(SOCKET_URL, {
      transports: ["websocket", "polling"],
      auth: { token },
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      autoConnect: true,
      withCredentials: true,
    });

    socket.on("connect", () => {
      console.log("✅ Socket connected:", socket.id);
    });

    socket.on("disconnect", (reason) => {
      console.log("❌ Socket disconnected:", reason);
    });

    socket.on("connect_error", (err) => {
      console.warn("⚠️ Socket connection error:", err.message);
    });
  }

  return socket;
};

export const updateSocketAuth = (newToken) => {
  const token =
    newToken ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("token");

  if (socket) {
    socket.auth = { token };
    if (!socket.connected) {
      socket.connect();
    }
  }
};

export default getSocket();
